import { createFileRoute } from "@tanstack/react-router";
import Insights from "@/pages/Insights";
import { fetchInsightsSsrData } from "@/lib/insightsSsrData";

export const Route = createFileRoute("/insights/")({
  loader: () => fetchInsightsSsrData(),
  component: InsightsRoute,
  errorComponent: () => <Insights />,
  notFoundComponent: () => <Insights />,
});

function InsightsRoute() {
  const data = Route.useLoaderData();
  return <Insights initialArticles={data.articles} initialCategories={data.categories} />;
}
